export default class deviceRequest {
  constructor(service) {
    this.service = service;
  }

  getGroupDeviceData$(groupId) {
    return this.service.fetch$({
      method: 'GET',
      url: `device/groupData?groupId=${groupId}`,
      timeout: 120000,
    });
  }

  getDeviceHistoryData$(from, to, deviceId, field) {
    return this.service.fetch$({
      method: 'GET',
      url: `/device/${deviceId}/history?from=${from}&to=${to}&field=${field}`,
    });
  }
}
